import { render, staticRenderFns } from "./printTicket.vue?vue&type=template&id=988e9200"
import script from "./printTicket.vue?vue&type=script&lang=js"
export * from "./printTicket.vue?vue&type=script&lang=js"
import style0 from "./printTicket.vue?vue&type=style&index=0&id=988e9200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports